import React from 'react';

// COMPONENTS
import Delete from '../../../Framework/Components/Buttons/Delete';
import Edit from '../../../Framework/Components/Buttons/Edit';
import Text from '../../../Framework/Components/Text';
import List from '../../../Framework/Pages/List/List';
import CategorySearch from '../CategorySearch';

const AgeCategoryList = (props) => {
    return (
        <List search={CategorySearch} {...props}>
            <Text name="id" />
            <Edit name="name" resource="categories" />
            <Text name="slug" />
            <Delete name="delete" list />
        </List>
    );
};

export default AgeCategoryList;
